var map = {
	"./1.png": 6439,
	"./10.png": 7975,
	"./11.png": 2190,
	"./12.png": 8917,
	"./13.png": 7292,
	"./2.png": 1612,
	"./4.png": 6554,
	"./5.png": 1779,
	"./6.png": 4920,
	"./7.png": 4865,
	"./8.png": 3382,
	"./9.png": 1471
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 991;